import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import logger from 'redux-logger'
import { isEmpty } from 'lodash'

import rootReducer from '@Root/slices'
import { dummyUser } from '@Root/store/dummy-user'

declare global {
  interface Window {
    __PRELOADED_STATE__: any
    __splugin: any
  }
  let SocialPlugIn_Core: any
}

let preloadedState = window.__PRELOADED_STATE__ || {}
delete window.__PRELOADED_STATE__
document.getElementById('__PRELOADED_STATE__')?.remove()

if (process.env.REACT_APP_ENV === 'LOCAL' && isEmpty(preloadedState) && dummyUser.useDummyUser) {
  preloadedState = {
    user: dummyUser.user,
  }
}

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    if (process.env.REACT_APP_REDUX_LOGGER === 'TRUE') {
      return getDefaultMiddleware().concat(logger)
    }
    return getDefaultMiddleware()
  },
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState: preloadedState,
})

export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()

export default store
